import React from "react";

/** Egyszerű szöveg: bekezdések + • sorok listaként. */
export function RenderServiceBody({ text, className = "" }) {
  if (!text) return null;
  const blocks = String(text).split(/\n\n+/);
  return (
    <div className={`space-y-3 text-sm text-slate-300 leading-relaxed ${className}`}>
      {blocks.map((block, bi) => {
        const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
        const bullets = lines.filter((l) => l.startsWith("•"));
        const paras = lines.filter((l) => !l.startsWith("•"));
        return (
          <div key={bi} className="space-y-2">
            {paras.map((p, pi) => (
              <p key={pi}>{p}</p>
            ))}
            {bullets.length > 0 && (
              <ul className="list-none space-y-1.5 pl-0">
                {bullets.map((b, li) => (
                  <li key={li} className="flex gap-2">
                    <span className="text-electric shrink-0">•</span>
                    <span>{b.replace(/^•\s*/, "")}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
}
